import { useState } from "react";
import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

const DEFAULT_ROOMS = [
  { type: "living", label: "Living" },
  { type: "dormitor", label: "Dormitor" },
  { type: "bucatarie", label: "Bucatarie" },
  { type: "baie", label: "Baie" },
  { type: "hol", label: "Hol" },
];

export default function PVSetupStep({ data, toggleField, setField }) {
  const [customRoom, setCustomRoom] = useState("");

  const selectedRooms = data.pvRooms || [];

  const countByType = (type) => selectedRooms.filter((r) => r.type === type).length;

  const addRoom = (type, label) => {
    const count = countByType(type);
    const num = count + 1;
    const displayLabel = num > 1 ? `${label} ${num}` : label;
    const id = `${type}_${num}`;
    setField("pvRooms", [...selectedRooms, { id, type, label: displayLabel, items: [], photos: [], observations: "" }]);
  };

  const removeRoom = (roomId) => {
    const room = selectedRooms.find((r) => r.id === roomId);
    if (!room) return;
    const filtered = selectedRooms.filter((r) => r.id !== roomId);
    // Renumber remaining rooms of the same type
    let counter = 0;
    const renumbered = filtered.map((r) => {
      if (r.type !== room.type) return r;
      counter++;
      const total = filtered.filter((x) => x.type === room.type).length;
      const newLabel = total > 1
        ? `${DEFAULT_ROOMS.find((d) => d.type === r.type)?.label || r.type} ${counter}`
        : DEFAULT_ROOMS.find((d) => d.type === r.type)?.label || r.type;
      return { ...r, id: `${r.type}_${counter}`, label: newLabel };
    });
    setField("pvRooms", renumbered);
  };

  const addCustomRoom = () => {
    const name = customRoom.trim();
    if (!name) return;
    const type = "custom_" + name.toLowerCase().replace(/\s+/g, "_");
    const count = countByType(type);
    const num = count + 1;
    const displayLabel = num > 1 ? `${name} ${num}` : name;
    const id = `${type}_${num}`;
    setField("pvRooms", [...selectedRooms, { id, type, label: displayLabel, items: [], photos: [], observations: "" }]);
    setCustomRoom("");
  };

  const btnStyle = {
    padding: "10px 20px",
    borderRadius: "10px",
    fontSize: "14px",
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    transition: "all 0.2s ease",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Toggle
        label="Activeaza Proces Verbal de Predare-Primire"
        description="Genereaza Anexa 1 cu inventar pe camere, poze si citiri contoare"
        checked={data.pvEnabled || false}
        onChange={toggleField("pvEnabled")}
      />
      <p style={{ fontSize: "11px", color: "#8a7e70", margin: "-8px 0 0 0", fontStyle: "italic" }}>
        Procesul-verbal face parte integranta din contract, daca este semnat de parti.
      </p>
      {data.mobilat && !data.pvEnabled && (
        <p style={{ fontSize: "11px", color: "#c45d3e", margin: "4px 0 0 0", fontStyle: "italic" }}>
          Recomandat pentru imobile mobilate.
        </p>
      )}

      {data.pvEnabled && (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            <InputField
              label="Data Proces Verbal"
              value={data.pvDate || ""}
              onChange={(e) => setField("pvDate", e.target.value)}
              type="date"
              half
            />
            <SelectField
              label="Starea generala a imobilului"
              value={data.pvStareGenerala || "buna"}
              onChange={(e) => setField("pvStareGenerala", e.target.value)}
              options={[
                { value: "buna", label: "Buna" },
                { value: "satisfacatoare", label: "Satisfacatoare" },
                { value: "necesita reparatii", label: "Necesita reparatii" },
              ]}
              half
            />
          </div>
          <p style={{ width: "100%", fontSize: "11px", color: "#8a7e70", margin: "-8px 0 0 0" }}>
            Starea este constatata vizual la data predarii.
          </p>
          {(data.pvStareGenerala === "satisfacatoare" || data.pvStareGenerala === "necesita reparatii") && (
            <>
              <p style={{ width: "100%", fontSize: "11px", color: "#c45d3e", margin: "4px 0 0 0", fontStyle: "italic" }}>
                Recomandat: completati observatii generale.
              </p>
              <div style={{ width: "100%", marginTop: "8px" }}>
                <label style={{
                  display: "block", fontSize: "13px", fontWeight: 600, color: "#4a3f35",
                  marginBottom: "6px", fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em",
                }}>
                  Observatii generale
                </label>
                <textarea
                  value={data.pvObservatiiGenerale || ""}
                  onChange={(e) => setField("pvObservatiiGenerale", e.target.value)}
                  placeholder={data.pvStareGenerala === "necesita reparatii"
                    ? "ex: zugraveala deteriorata in mai multe camere, parchet uzat in zonele de circulatie, infiltratii minore in baie"
                    : "ex: parchet zgariat langa fereastra, tencuiala crapata pe peretele nordic"}
                  rows={3}
                  style={{
                    width: "100%", padding: "12px 16px",
                    border: "2px solid #e8e0d4", borderRadius: "10px",
                    fontSize: "15px", fontFamily: "'DM Sans', sans-serif",
                    backgroundColor: "#fdfbf7", color: "#2d2418",
                    outline: "none", boxSizing: "border-box",
                    resize: "vertical",
                  }}
                />
              </div>
            </>
          )}

          <div>
            <label style={{
              display: "block", fontSize: "13px", fontWeight: 600,
              color: "#4a3f35", marginBottom: "10px",
              fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em",
            }}>
              Adauga camere / zone (apasa de mai multe ori pentru duplicat)
            </label>

            {/* Add buttons for default room types */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {DEFAULT_ROOMS.map((room) => {
                const count = countByType(room.type);
                return (
                  <button
                    key={room.type}
                    onClick={() => addRoom(room.type, room.label)}
                    style={{
                      ...btnStyle,
                      border: `2px solid ${count > 0 ? "#c45d3e" : "#e8e0d4"}`,
                      backgroundColor: count > 0 ? "rgba(196, 93, 62, 0.08)" : "#fdfbf7",
                      color: count > 0 ? "#c45d3e" : "#4a3f35",
                      fontWeight: count > 0 ? 700 : 500,
                    }}
                  >
                    + {room.label} {count > 0 && `(${count})`}
                  </button>
                );
              })}
            </div>

            {/* Selected rooms list */}
            {selectedRooms.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "12px" }}>
                {selectedRooms.map((room) => (
                  <div
                    key={room.id}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 14px",
                      borderRadius: "10px",
                      border: "2px solid #c45d3e",
                      backgroundColor: "rgba(196, 93, 62, 0.08)",
                      color: "#c45d3e",
                      fontWeight: 600,
                      fontSize: "13px",
                      fontFamily: "'DM Sans', sans-serif",
                    }}
                  >
                    {room.label}
                    <button
                      onClick={() => removeRoom(room.id)}
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        border: "none",
                        backgroundColor: "#c45d3e",
                        color: "#fff",
                        fontSize: "11px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                        lineHeight: 1,
                      }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Add custom room */}
            <div style={{ display: "flex", gap: "8px", marginTop: "12px", alignItems: "flex-end" }}>
              <div style={{ flex: 1 }}>
                <InputField
                  label="Adauga zona custom"
                  value={customRoom}
                  onChange={(e) => setCustomRoom(e.target.value)}
                  placeholder="ex: Balcon, Debara, Terasa..."
                />
              </div>
              <button
                onClick={addCustomRoom}
                style={{
                  padding: "12px 24px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #c45d3e 0%, #a84832 100%)",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: "'DM Sans', sans-serif",
                  cursor: "pointer",
                  height: "46px",
                  whiteSpace: "nowrap",
                }}
              >
                + Adauga
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
